import React, { useEffect, useState } from "react";
import axios from "axios";

const SpeakerProfileDetails = () => {
  const BaseUrl = "https://eventscons.com/eventbackendnew/api";
  const token = localStorage.getItem("token");
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchSpeakerDetails = async () => {
      try {
        const res = await axios.get(`${BaseUrl}/speakers/info`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = res.data.speaker;
        setDetails(data);
      } catch (err) {
        console.error("Error fetching details:", err);
        setError("Failed to load details. Check token or try again.");
      } finally {
        setLoading(false);
      }
    };
    fetchSpeakerDetails();
  }, [token]);

  if (loading) return <p>Loading details...</p>;
  if (error) return <p style={{ color: "red" }}>{error}</p>;
  if (!details) return <p>No details found.</p>;

  return (
    <div style={containerStyle}>
      <h2 style={titleStyle}>Speaker Benefits Details</h2>
      <div style={detailsBox}>
        <Detail label="Online Approved" value={details.is_online_approved ? "Yes" : "No"} />
        <Detail label="Certificate Active" value={details.is_certificate_active ? "Yes" : "No"} />
        
        <Detail label="Flight Ticket" value={details.flight_ticket} />
        <Detail label="Room Type" value={details.room_type} />
        <Detail label="Accommodation Nights" value={details.nights_covered} />
        <Detail label="Transportation" value={details.transportation} />
        <Detail label="Visa Fees" value={details.visa_fees} />
        <Detail label="Conference Dinner" value={details.conference_dinner} />
        <Detail label="Dinner Persons" value={details.conference_dinner_persons} />
        <Detail label="Social Trip" value={details.social_trip} />
        <Detail label="Registration Fee" value={details.registration_fee} />
        <Detail label="Other" value={details.other} />
      </div>
    </div>
  );
};

const Detail = ({ label, value }) => (
  <div style={detailRow}>
    <strong>{label}:</strong> <span>{value || "N/A"}</span>
  </div>
);

const containerStyle = {
  maxWidth: "600px",
  margin: "40px auto",
  padding: "20px",
  borderRadius: "12px",
  backgroundColor: "#fff",
  boxShadow: "0 0 12px rgba(0,0,0,0.1)",
  fontFamily: "Segoe UI, sans-serif",
};

const titleStyle = {
  textAlign: "center",
  marginBottom: "20px",
  color: "#a30000",
};

const detailsBox = {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

const detailRow = {
  display: "flex",
  justifyContent: "space-between",
  padding: "8px 12px",
  background: "#f9f9f9",
  borderRadius: "6px",
};

export default SpeakerProfileDetails;